<h2 mat-dialog-title>Stop accepting online orders?</h2>

<mat-dialog-content>
  <p class="body-2 text-secondary">
    Customers won't be able to place online orders until you re-enable this.
    Existing pay-by-link orders will still work.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="warn" type="button" (click)="confirm()">
    Stop online ordering
  </button>
</mat-dialog-actions>
